import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { GROUP_TYPES, DEFAULT_GROUP_TYPE } from './groupTypes';

// Create / edit a job group's name, type, and description. Steps are managed inline on
// the card. `presetTypeKey` pre-selects the type when creating from the New dropdown;
// `group` is expected pre-decoded (clean description + typeKey).
function GroupDialog({ show, mode, group, presetTypeKey, onHide, onSave }) {
  const [name, setName] = useState('');
  const [typeKey, setTypeKey] = useState(DEFAULT_GROUP_TYPE);
  const [description, setDescription] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (show) {
      setName((group && group.name) || '');
      setTypeKey((group && group.typeKey) || presetTypeKey || DEFAULT_GROUP_TYPE);
      setDescription((group && group.description) || '');
      setError(null);
    }
  }, [show, group, presetTypeKey]);

  const handleSave = () => {
    if (!name.trim()) {
      setError('Group name is required.');
      return;
    }
    onSave({ name: name.trim(), typeKey, description: description.trim() || null });
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title as='h5'>{mode === 'edit' ? 'Edit group' : 'New group'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant='danger'>{error}</Alert>}
        <Form.Group>
          <Form.Label>Name</Form.Label>
          <Form.Control
            data-testid='job-group-name'
            value={name}
            maxLength={256}
            onChange={(e) => setName(e.target.value)}
            placeholder='e.g. Nightly CRM refresh'
            autoFocus
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Type</Form.Label>
          <Form.Control
            as='select'
            data-testid='job-group-type'
            value={typeKey}
            onChange={(e) => setTypeKey(e.target.value)}
          >
            {GROUP_TYPES.map((t) => (
              <option key={t.key} value={t.key}>
                {t.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group className='mb-0'>
          <Form.Label>Description (optional)</Form.Label>
          <Form.Control
            as='textarea'
            rows={2}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder='What this group keeps in sync, and why the order matters'
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-secondary' size='sm' onClick={onHide}>
          Cancel
        </Button>
        <Button variant='primary' size='sm' data-testid='job-group-save' onClick={handleSave}>
          {mode === 'edit' ? 'Save' : 'Create group'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default GroupDialog;
